export default "__VITE_ASSET__ac53639a__"